'use client'

import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { noop } from 'lodash'
import { PageAction } from '../types'

export interface ActionsProps {
	items?: any[]
	onClick?: any
	event?: string
	sx?: any
}

const Action = ({ label, icon, link, event, onClick = noop, disabled }: PageAction) => {
	if (label) {
		if (link) {
			return (
				<Button variant="contained" LinkComponent={'a'} disabled={disabled} href={link}>
					{icon}
					{label}
				</Button>
			)
		}
		return (
			<Button variant="contained" onClick={() => onClick(event)} disabled={disabled}>
				{icon}
				{label}
			</Button>
		)
	}

	if (link) {
		return (
			<IconButton LinkComponent={'a'} disabled={disabled} href={link}>
				{icon}
			</IconButton>
		)
	}

	return (
		<IconButton onClick={() => onClick(event)} disabled={disabled}>
			{icon}
		</IconButton>
	)
}

export default function Actions({ items = [], onClick = noop, sx = {} }: ActionsProps) {
	return (
		<Box sx={sx.actions}>
			{items.map((item: any, index: number) => (
				<Action key={index} {...item} onClick={onClick} />
			))}
		</Box>
	)
}
